import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import tscStyles from '../constants/TscStyles';
import { getClassName } from '../utils/get-class-name';
var MenuItemWrapper = styled.li.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "MenuItem__MenuItemWrapper"
})(["white-space:nowrap;font-size:.875rem;color:", ";background:", ";font-family:inherit;text-align:left;text-decoration:none;display:block;user-select:none;cursor:", ";border:none;margin:2px;list-style:none;opacity:", ";border-radius:", ";a,button{text-overflow:ellipsis;overflow:hidden;box-sizing:border-box;}&:active{background-color:", ";}"], tscStyles.color.text.mediumDark, tscStyles.color.global.white, function (props) {
  return !props.isDisabled && 'pointer';
}, function (props) {
  return props.isDisabled ? '.6' : '1';
}, tscStyles.border.radius.md, tscStyles.color.ui.dawn.medium);
var GlyphContainer = styled.span.withConfig({
  displayName: "MenuItem__GlyphContainer"
})(["margin:0 1rem 0 0.5rem;svg{vertical-align:middle;}"]);
var TextContainer = styled.span.withConfig({
  displayName: "MenuItem__TextContainer"
})(["margin-right:", ";overflow:hidden;text-overflow:ellipsis;"], function (props) {
  return props.hasGlyph ? '0.5rem' : 0;
});
var MenuButton = styled.button.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "MenuItem__MenuButton"
})(["margin:0;border:0;background:transparent;font-size:0.875rem;font-family:inherit;color:inherit;fill:currentColor;text-decoration:none;width:100%;height:100%;padding:0.5rem;text-align:left;display:flex;align-items:center;cursor:", ";border:2px solid transparent;border-radius:", ";transition:background-color 150ms ease-out;::-moz-focus-inner{padding:0;border:0;}&:focus{border-color:", ";outline:none;}&:hover{background-color:", ";}"], function (props) {
  return !props.isDisabled && 'pointer';
}, tscStyles.border.radius.md, function (props) {
  return !props.isDisabled && 'currentColor';
}, tscStyles.color.ui.dawn.medium);
var MenuLink = styled.a.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "MenuItem__MenuLink"
})(["display:flex;align-items:center;font-size:0.875rem;text-decoration:none;padding:.5rem;color:inherit;fill:currentColor;border:2px solid transparent;border-radius:", ";transition:background-color 150ms ease-out;&:focus{border-color:", ";outline:none;}&:hover{background-color:", ";}"], tscStyles.border.radius.md, function (props) {
  return !props.isDisabled && 'currentColor';
}, tscStyles.color.ui.dawn.medium);

var MenuItem = function MenuItem(_ref) {
  var className = _ref.className,
      glyph = _ref.glyph,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '' : _ref$href,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      onClick = _ref.onClick,
      _ref$openInNewTab = _ref.openInNewTab,
      openInNewTab = _ref$openInNewTab === void 0 ? false : _ref$openInNewTab,
      testId = _ref.testId;

  var localOnClick = function localOnClick(e) {
    if (onClick && !isDisabled) {
      e.preventDefault();
      onClick(e);
    }
  };

  var menuItemLinkTestId = testId ? "".concat(testId, "-link") : '';
  var menuItemButtonTestId = testId ? "".concat(testId, "-button") : '';

  var menuItemContent = _jsxs(_Fragment, {
    children: [glyph && _jsx(GlyphContainer, {
      className: getClassName(className, 'glyph-container'),
      children: glyph
    }), label && _jsx(TextContainer, {
      className: getClassName(className, 'text-container'),
      hasGlyph: !!glyph,
      children: label
    })]
  });

  return _jsxs(MenuItemWrapper, {
    className: getClassName(className, null, 'menu-item-wrapper'),
    isDisabled: isDisabled,
    testId: testId,
    children: [href && _jsx(MenuLink, {
      className: getClassName(className, 'menu-link'),
      href: href,
      isDisabled: isDisabled,
      onClick: localOnClick,
      testId: menuItemLinkTestId,
      target: openInNewTab ? '_blank' : undefined,
      rel: openInNewTab ? 'noopener noreferrer nofollow' : undefined,
      children: menuItemContent
    }), !href && onClick && _jsx(MenuButton, {
      className: getClassName(className, 'menu-button'),
      isDisabled: isDisabled,
      onClick: localOnClick,
      testId: menuItemButtonTestId,
      children: menuItemContent
    })]
  }, "menu-item-".concat(label));
};

var MenuItemTest = {
  MenuButton: MenuButton,
  MenuLink: MenuLink
};
export { MenuItem, MenuItemTest };
export default MenuItem;